<template>
  <div class="modal-assign">
  <Modal :config="modal">
    <template v-slot:header>
      <h4 class="title is-4">{{translations.assign_devices_event}}</h4>
    </template>
    <VueSelect :config="selectEvent" v-model="eventId" @search="onSearch" />

    <template v-slot:footer>
      <button
        class="button is-success"
        @click="submit()"
      >{{translations.assign_devices}} ({{selected.length}})</button>
    </template>
  </Modal>
  </div>

</template>
<style lang="scss">
.modal-assign .modal-card-body {
  overflow: visible !important;
}
</style>
<script lang="ts">
// @ is an alias to /src
import { IVSelect } from '@/components/form';
import VueSelect from '@/components/form/vue-select/vue-select.vue';
import Modal from '@/components/modal.vue';
import router from '@/router';
import store from '@/store';
import { IBulkDevicesEvent, IStateDevice } from '@/store/modules/devices';
import { IStateEvent } from '@/store/modules/events';
import { IDevicesTranslations } from '@/translations';
import { Component, Vue } from 'vue-property-decorator';
import { MutationPayload } from 'vuex';
import { Action, Getter } from 'vuex-class';

import { deviceModal } from './../';

@Component({
  name: 'AssignDevices',
  components: { Modal, VueSelect },
  watch: {
    events: {
      handler: 'mapEventsToSelectOptions',
      immediate: false
    }
  }
})
class AssignDevices extends Vue {
  @Action('fetchEvents') public fetch!: (params?: { page?: number, pageSize?: number, type?: string, search?: string }) => void;

  @Getter('getEvents') public events!: IStateEvent[];

  @Action('assignDevices') public assign!: (devices: IBulkDevicesEvent) => void;

  @Getter('getSelectedDevices') public selected!: number[];

  @Getter('getDevicesTranslations') public translations!: IDevicesTranslations;
  public eventId = '';
  public modal = deviceModal;
  public selectEvent: IVSelect = {
    id: 'select-event',
    label: 'Select event',
    placeholder: 'Select Event',
    value: '',
    options: []
  };
  public id = 0;
  public searchTimeout: number | null = null;
  public created() {
    if (this.events.length > 0) {
      this.mapEventsToSelectOptions();
    } else {
      this.fetch();
      const unsubscribe = store.subscribe((mutation: MutationPayload) => {
        if (mutation.type === 'setEvents') {
         this.mapEventsToSelectOptions();
         unsubscribe();
       }
      });
    }
  }
  public mapEventsToSelectOptions() {
    this.selectEvent = {
      ...this.selectEvent,
      options: this.events.map(event => ({
        value: event.id ? event.id : 0,
        label: event.name
      }))
    };
  }
  public submit() {
    if (this.eventId === '') {
      return;
    }

    const eventId = parseInt(this.eventId, 10);
    const selectedEvent = this.selectEvent.options.find(option => option.value === eventId);

    if (!selectedEvent) {
      return;
    }

    this.assign({
      ids: this.selected,
      current_event_id: eventId,
      event_name: selectedEvent.label
    });

    router.push('/devices');
  }
  public onSearch(value: string) {
    // Clear the previous timeout if it exists
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set a new timeout to execute the search after 1.5 seconds
    this.searchTimeout = window.setTimeout(() => {
      // Fetch events with search parameter
      // The watcher will automatically update the options when events change
      this.fetch({ search: value });
    }, 1200);
  }
  public close() {
    router.push('/devices');
  }
  public beforeDestroy() {
    // Clear timeout on component destroy to prevent memory leaks
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
}

export default AssignDevices;
</script>
